'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import useLazyRef from '@mui/utils/useLazyRef';
/**
 * Lazy initialization container for the Ripple instance. This improves
 * performance by delaying mounting the ripple until it's needed.
 */ export var LazyRipple = /*#__PURE__*/ function() {
    "use strict";
    function LazyRipple() {
        var _this = this;
        _class_call_check(this, LazyRipple);
        _define_property(this, "mountEffect", function() {
            if (_this.shouldMount && !_this.didMount) {
                if (_this.ref.current !== null) {
                    _this.didMount = true;
                    _this.mounted.resolve();
                }
            }
        });
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    _create_class(LazyRipple, [
        {
            key: "mount",
            value: function mount() {
                if (!this.mounted) {
                    this.mounted = createControlledPromise();
                    this.shouldMount = true;
                    this.setShouldMount(this.shouldMount);
                }
                return this.mounted;
            }
        },
        {
            /* Ripple API */ key: "start",
            value: function start() {
                var _this = this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.mount().then(function() {
                    var _this_ref_current;
                    var _this_ref_current1;
                    return (_this_ref_current1 = _this.ref.current) === null || _this_ref_current1 === void 0 ? void 0 : (_this_ref_current = _this_ref_current1).start.apply(_this_ref_current, _to_consumable_array(args));
                });
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this = this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.mount().then(function() {
                    var _this_ref_current;
                    var _this_ref_current1;
                    return (_this_ref_current1 = _this.ref.current) === null || _this_ref_current1 === void 0 ? void 0 : (_this_ref_current = _this_ref_current1).stop.apply(_this_ref_current, _to_consumable_array(args));
                });
            }
        },
        {
            key: "pulsate",
            value: function pulsate() {
                var _this = this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.mount().then(function() {
                    var _this_ref_current;
                    var _this_ref_current1;
                    return (_this_ref_current1 = _this.ref.current) === null || _this_ref_current1 === void 0 ? void 0 : (_this_ref_current = _this_ref_current1).pulsate.apply(_this_ref_current, _to_consumable_array(args));
                });
            }
        }
    ], [
        {
            key: "create",
            value: /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ function create() {
                return new LazyRipple();
            }
        },
        {
            key: "use",
            value: function use() {
                /* eslint-disable */ var ripple = useLazyRef(LazyRipple.create).current;
                var _React_useState = _sliced_to_array(React.useState(false), 2), shouldMount = _React_useState[0], setShouldMount = _React_useState[1];
                ripple.shouldMount = shouldMount;
                ripple.setShouldMount = setShouldMount;
                React.useEffect(ripple.mountEffect, [
                    shouldMount
                ]);
                /* eslint-enable */ return ripple;
            }
        }
    ]);
    return LazyRipple;
}();
export default function useLazyRipple() {
    return LazyRipple.use();
}
function createControlledPromise() {
    var resolve;
    var reject;
    var p = new Promise(function(resolveFn, rejectFn) {
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}
